<template>
  <div class="weui-cell addepage" :class="{on:selectIdx==index}" @click="onSelect">
    <div class="weui-cell__hd">
      <el-upload
        class="addicon addicon3"
        ref="imgupload"
        :data="uploaddata"
        :action="uploadurl"
        :show-file-list="false"
        accept="image/jpeg,image/png"
        :on-success="handleSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload">
          <div v-if="from.page_img" class="imgbox">
            <img :src="from.page_img" />
            <div class="abs">
              <i class="el-icon-zoom-in" @click.stop="onClickImage"></i>
              <i class="el-icon-delete" @click.stop="onClickDel"></i>
            </div>
          </div>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>    
    </div>
    <div class="weui-cell__bd">
      <el-form ref="form" :model="from" label-width="100px">
        <el-form-item label="页面名称：" class="elform">
          <el-input class="w200" v-model="from.page_name" maxlength="8" show-word-limit></el-input>
        </el-form-item>    
        <el-form-item label="页面跳转：" class="elform">
          <span class="whd-gray666" v-if="from.jump_type==0">不跳转</span>
          <span class="whd-gray666" v-else>{{from.item_name}}</span>
          <el-dropdown class="ml-10" @command="handleCommand">
            <span class="el-dropdown-link required whd-hand">
              修改<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="2">商品</el-dropdown-item>
              <el-dropdown-item command="1">表单</el-dropdown-item>
              <el-dropdown-item command="0">不跳转</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>          
        </el-form-item>   
        <el-form-item label="按钮文案：" class="elform mb0" v-if="from.jump_type!=0">
          <el-input class="w200" v-model="from.button_text" maxlength="8" show-word-limit></el-input>
        </el-form-item>                   
      </el-form>  
    </div>
    <i class="el-icon-error" @click.stop="handlerDelPage"></i>
  </div>
</template>

<script>
import api from "@/api.js";
export default {
  name: "addPageBrochure",
  props: ["index", "selectIdx", "property"],
  data() {
    return {
      uploadurl: api.uploadTokenImg,
      uploaddata: {token: sessionStorage.getItem("token")}
    }
  },
  watch: {
    property: {
      immediate: true,
      handler(newVal, oldVal) {
        let obj = newVal;
        this.from = obj;
      },
      deep: true
    }
  },
  mounted() {
    this.$emit('update:property', this.from);
  },
  methods: {
    onClickImage() {
      this.$emit("previewImage", {url: this.from.page_img, title: this.from.page_name});
    },
    onClickDel() {
      this.from.page_img = "";
    },
    onSelect() {
      this.$emit("onChange", this.index)
    },
    handlerDelPage() {
      this.$confirm('确认删除该页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.from.page_id && this.from.page_id != 0) {
          this.axios
            .post(api.brochure_pagedel, {page_id: this.from.id})
            .then(response => {
              if (response.data.code == 0) {
                this.$emit("onDelPage", this.index);
              } else {
              }
            })
            .catch(() => {});            
        } else {
          this.$emit("onDelPage", this.index);
        }      
      }).catch(() => {
           
      });      
    },
    handleCommand(command) {
      this.from.jump_type = command;
      this.$emit("onGoodsOrForm", {type: command, index: this.index});
    }, 
    handleError(err, file) {
      this.$message({
        type: "error",
        message: "上传失败"
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      let status = true;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        status = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        status = false;
      }
      if(status){
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }
      return isJPG && isLt2M;
    },
    handleSuccess(res, file) {
      if (res.code === 0) {
        this.from.page_img = res.path;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },       
  }
}
</script>

<style type="text/css" scoped>
.addepage{padding: 15px; -webkit-box-align: start; -ms-flex-align: start; align-items: start;}
.addepage .elform{margin-bottom: 5px;}
.addicon3 .avatar-uploader-icon, .addicon3 .imgbox{margin-top: 0;}
</style>